import { StylesDerivedNativeActions } from '@wix/editor-platform-host-integration-apis';
import createDefaultActionDefinition from '../common/actionDefinition/default';

const textAction = createDefaultActionDefinition(
  StylesDerivedNativeActions.textStyles,
);

export default textAction;
